module.exports = __webpack_public_path__ + "img/55.5254c54a.jpg";